import { useDispatch } from "react-redux";
import DynamicIcon from "../DynamicIcon";
import { closeModal, setModal } from "../../redux/rightModalSlice";

export default function CarrierCard({ carrier, index }) {
    const dispatch = useDispatch();
    
    // Gestisce il click sull'icona di modifica
    const handleEditClick = () => {
        dispatch(setModal({
            mode: 'edit',
            id: carrier._id
        }));
    };
    
    // Gestisce il click sull'icona di visualizzazione
    const handleViewClick = () => {
        dispatch(setModal({
            mode: 'view',
            id: carrier._id
        }));
    };
    
    return (
        <div className="bg-white shadow-lg rounded-lg p-4 border border-gray-200 flex flex-col">
            <div className="flex justify-between items-start">
                <div className="flex-1">
                    <h3 className="text-lg font-semibold mb-1 text-primary-600">
                        {carrier.company || "Corriere senza nome"}
                    </h3>
                    
                    {carrier.code && (
                        <p className="text-sm mb-2 text-gray-600">
                            <span className="font-medium">Codice:</span> {carrier.code}
                        </p>
                    )}
                    
                    {carrier.address && (
                        <p className="text-sm mb-2 text-gray-600">
                            <span className="font-medium">Indirizzo:</span> {carrier.address}
                            {carrier.city && `, ${carrier.city}`}
                            {carrier.province && ` (${carrier.province})`}
                        </p>
                    )}
                    
                    <div className="flex flex-wrap gap-2 mt-2">
                        {carrier.email && (
                            <p className="text-sm text-gray-600 flex items-center">
                                <DynamicIcon iconClass="fas fa-envelope text-blue-500 mr-1" />
                                {carrier.email}
                            </p>
                        )}
                        
                        {carrier.phone && (
                            <p className="text-sm text-gray-600 flex items-center">
                                <DynamicIcon iconClass="fas fa-phone text-green-500 mr-1" />
                                {carrier.phone}
                            </p>
                        )}
                    </div>
                </div>
                
                <div className="flex space-x-2">
                    <button
                        onClick={handleViewClick}
                        className="p-1 rounded-full text-blue-500 hover:bg-blue-100 transition-colors"
                        title="Visualizza Dettagli"
                    >
                        <DynamicIcon iconClass="fas fa-eye" />
                    </button>
                    
                    <button
                        onClick={handleEditClick}
                        className="p-1 rounded-full text-green-500 hover:bg-green-100 transition-colors"
                        title="Modifica Corriere"
                    >
                        <DynamicIcon iconClass="fas fa-edit" />
                    </button>
                </div>
            </div>
        </div>
    );
}
